import { render, staticRenderFns } from "./ResaleItemWarning.vue?vue&type=template&id=d719c89c&scoped=true"
import script from "./ResaleItemWarning.vue?vue&type=script&lang=js"
export * from "./ResaleItemWarning.vue?vue&type=script&lang=js"
import style0 from "./ResaleItemWarning.vue?vue&type=style&index=0&id=d719c89c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d719c89c",
  null
  
)

export default component.exports